var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.25 0L5.25 0C5.05 0 4.86 0.07 4.71 0.21C4.57 0.36 4.5 0.55 4.5 0.75L4.5 4.5L0.75 4.5C0.55 4.5 0.36 4.57 0.21 4.71C0.07 4.86 0 5.05 0 5.25L0 17.25C0 17.44 0.07 17.63 0.21 17.78C0.36 17.92 0.55 18 0.75 18L12.75 18C12.94 18 13.13 17.92 13.28 17.78C13.42 17.63 13.5 17.44 13.5 17.25L13.5 13.5L17.25 13.5C17.44 13.5 17.63 13.42 17.78 13.28C17.92 13.13 18 12.94 18 12.75L18 0.75C18 0.55 17.92 0.36 17.78 0.21C17.63 0.07 17.44 0 17.25 0ZM12 16.5L1.5 16.5L1.5 6L12 6L12 16.5ZM16.5 12L13.5 12L13.5 5.25C13.5 5.05 13.42 4.86 13.28 4.71C13.13 4.57 12.94 4.5 12.75 4.5L6 4.5L6 1.5L16.5 1.5L16.5 12Z",
    fill: "#1F0A35",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copyLinkIcon.b9cd73124214a2006524bb72fee599f1.svg";
export { ForwardRef as ReactComponent };